// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"919b0de0","167":"d9ad3350","189":"6eb6f730","453":"7a37e4ba","510":"aaf5137c","629":"cf6943b7","779":"d3fabf8f","845":"5deb3ef7","911":"4f3ac882","984":"cff8ce2c"}[chunkId] + ".chunk.js";
};